var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "pencil")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.72 1.056c-0.352 0.144-4 3.664-9.968 9.632-5.184 5.168-9.472 9.504-9.552 9.648-0.272 0.48-2.88 10.016-2.88 10.512 0 0.304 0.128 0.64 0.336 0.848 0.496 0.496 1.12 0.384 6.544-1.136l4.72-1.328 9.552-9.536c9.488-9.488 9.536-9.536 9.808-10.48 0.304-1.056 0.24-1.888-0.24-2.784-0.464-0.912-4.592-4.912-5.44-5.296s-2.096-0.416-2.88-0.080zM26.656 5.456c1.168 1.152 2.144 2.224 2.192 2.368 0.112 0.448-0.128 0.848-1.216 2.016l-1.056 1.12-5.216-5.216 1.216-1.184c0.8-0.784 1.344-1.2 1.584-1.2 0.256 0 1.008 0.64 2.496 2.096zM8.624 27.36c0.016 0.112-4.96 1.472-5.056 1.392-0.064-0.064 1.040-4.256 1.328-5.072 0.064-0.16 0.64 0.336 1.904 1.68 1.008 1.056 1.824 1.952 1.824 2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.03f45597.svg";
export { ForwardRef as ReactComponent };